require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-iterated-digits-squaring.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-iterated-digits-squaring");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-iterated-digits-squaring!./.cache/json/coding-interview-prep-rosetta-code-iterated-digits-squaring.json
// module id = 1906
// module chunks = 231608221292675